// extracted by mini-css-extract-plugin
export default {"container":"ytsyvylHS2H3UGIx46uw","item":"NSrBaLT7bvQtG32xJ2_Q"};